<div class="flex items-center gap-4">
  <div
    class="header-icon flex items-center p-3 rounded-full bg-bg-primary-default text-fg-primary-default"
  >
    <ng-content select="svg"></ng-content>
  </div>
  <div class="flex flex-col gap-1">
    <h4><ng-content select="[header]"></ng-content></h4>
    <p class="body-xs text-fg-muted max-text-block-width">
      <ng-content></ng-content>
    </p>
  </div>
</div>
